// Module
var code = `<section class="negocio"
    id="negocio">

    <div class="container">
        <div class="negocio__list negocio__owl owl-carousel">


            <article class="negocio__slide"
                ng-repeat="item in \$ctrl.negocio.items track by \$index"
                id="negocio-{{\$index+1}}">
                <div class="row align-items-lg-center">
                    <div class="col-lg-6 no-gutter"
                        ng-class="{'order-lg-2': \$index % 2 === 0}">
                        <div class="negocio__media">
                            <img class="negocio__img"
                                ng-src="{{item.image}}"
                                alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 ">
                        <div class="
                        negocio__body">

                            <h3 class="negocio__title"
                                ng-bind-html="item.title">
                            </h3>

                            <div class="negocio__text"
                                ng-bind-html="item.text">
                            </div>

                            <!-- <a ng-if="item.cta"
                                class="negocio__cta link-global link-global--semi-block link-global--purple"
                                ng-href="{{item.cta.url}}">
                                {{ item.cta.label }}
                            </a> -->

                        </div>
                    </div>


                </div>
            </article>

        </div>
    </div>



</section>`;
// Exports
export default code;